// src/features/nameDescription/nameDescriptionSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
 rolesDetailsData:[]
};

const rolesDetailsSlice = createSlice({
  name: 'rolesDetails',
  initialState,
  reducers: {
    rolesDetailsDataFunc: (state, action) => {
      state.rolesDetailsData = action.payload;
    },
    
  },
});

export const { rolesDetailsDataFunc } = rolesDetailsSlice.actions;

export default rolesDetailsSlice.reducer;
